package services

import business.GoogleSheetsLeadConfig
import kotlin.js.Promise
import kotlinx.browser.window
import kotlinx.coroutines.await
import org.w3c.fetch.RequestInit

class BrowserGoogleSheetsLeadService(
    private val config: GoogleSheetsLeadConfig,
    private val nowIso: () -> String = ::nowIso,
    private val dispatch: (String, RequestInit) -> Promise<Unit> = { url, request ->
        window.fetch(url, request).then { Unit }
    },
) : LeadService {
    override suspend fun submit(submission: LeadSubmission): SubmissionResult {
        if (!config.isConfigured()) {
            return SubmissionResult.Failed("Google Sheets lead delivery is not configured")
        }

        return try {
            val request = RequestInit(
                method = "POST",
                headers = textHeaders(),
                body = submission.toGoogleSheetsJsonPayload(config.token, nowIso()),
            )
            request.asDynamic().mode = "no-cors"
            dispatch(config.webhookUrl, request).await()
            SubmissionResult.Submitted
        } catch (_: Throwable) {
            SubmissionResult.Failed("Google Sheets lead delivery is unavailable")
        }
    }
}

internal fun textHeaders(): dynamic = js("({'Content-Type': 'text/plain;charset=UTF-8'})")
